<template>
  <div style="max-height: 100px">
    <b-modal id="modalTypeOfSchedule" centered hide-header>
      <template #modal-footer>
        <div style="width: 100%; display: flex; justify-content: space-between">
          <button
            class="btnsModal"
            variant="info"
            size="sm"
            @click="handleCloseModalAndClear"
          >
            Fechar
          </button>
          <button
            class="btnsModal btnSave"
            variant="info"
            size="sm"
            @click="saveOrUpdate"
          >
            Salvar
          </button>
        </div>
      </template>
      <div class="mt-3">
        <div class="titleCard">
          <p>Tipo de agendamento</p>
        </div>
        <div>
          <label style="font-size: 14px; color: #666360">
            Informe abaixo o tipo de agendamento
          </label>
          <div>
            <Input
              type="text"
              :dataInput.sync="dataTypeOfSchedule.name"
              ref="typeOfScheduleName"
            />
          </div>
        </div>

        <table class="table table-sm mt-5">
          <thead>
            <tr style="width: 100%">
              <th style="width: 50%; font-size: 14px; font-weight: 600">
                Nome
              </th>
              <th
                style="
                  width: 50%;
                  text-align: center;
                  font-size: 14px;
                  font-weight: 600;
                  padding: 0 10px;
                "
              >
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="typeOfSchedule in dataAllTypeOfSchedule" :key="typeOfSchedule.id">
              <td style="font-size: 14px">{{ typeOfSchedule.name }}</td>
              <td
                style="
                  text-align: center;
                  padding: 0 !important;
                  display: flex;
                  height: 100%;
                  justify-content: center;
                  gap: 20px;
                  padding: 0.5rem;
                "
              >
                <b-icon-pencil
                  @click="getTypeOfScheduleFindById(typeOfSchedule.id)"
                  scale="1"
                  role="button"
                />

                <b-icon-x-circle
                  @click="deleteTypeOfSchedule(typeOfSchedule.id)"
                  role="button"
                  style="color: red"
                  scale="1"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ServiceTypeOfSchedule from "../../services/serviceTypeOfSchedule";
import Input from "../UI/CustomInputs/Input.vue";

export default {
  data() {
    return {
      dataTypeOfSchedule: {
        id: "",
        name: "",
      },
      dataAllTypeOfSchedule: [],
    };
  },
  components: {
    Input,
  },
  methods: {
    async saveTypeOfSchedule() {
      try {
        await ServiceTypeOfSchedule.save(this.dataTypeOfSchedule);
        this.getAllTypeOfSchedule();

        this.$emit("getNewTypeOfSchedule");

        return this.$toast.open({
          message: "Salvo com sucesso!",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message:
            `${error.response.data.erros}` || "Ocorreu um erro o salvar!",
          type: "info",
        });
      }
    },

    async updateTypeOfSchedule() {
      try {
        await ServiceTypeOfSchedule.update(this.dataTypeOfSchedule);
        this.getAllTypeOfSchedule();

        this.$emit("getNewTypeOfSchedule");

        return this.$toast.open({
          message: "Atualizado com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um problema ao deletar!",
          type: "info",
        });
      }
    },

    async deleteTypeOfSchedule(idTypeOfSchedule) {
      try {
        await ServiceTypeOfSchedule.delete(idTypeOfSchedule);
        this.getAllTypeOfSchedule();

        this.$emit("getNewTypeOfSchedule");

        return this.$toast.open({
          message: "deletado com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um problema ao deletar!",
          type: "info",
        });
      }
    },

    async getTypeOfScheduleFindById(idTypeOfSchedule) {
      const result = await ServiceTypeOfSchedule.findById(idTypeOfSchedule);
      Object.assign(this.dataTypeOfSchedule, result);
      this.$refs.typeOfScheduleName.valueInput = result.nome;
    },

    async getAllTypeOfSchedule() {
      const result = await ServiceTypeOfSchedule.fillComobobox();
      this.dataAllTypeOfSchedule = result;
    },

    async saveOrUpdate() {
      this.dataTypeOfSchedule.id === ""
        ? await this.saveTypeOfSchedule()
        : await this.updateTypeOfSchedule();
      this.clear();
    },

    clear() {
      this.dataTypeOfSchedule.id = "";
      this.dataTypeOfSchedule.name = "";
      this.$refs.typeOfScheduleName.valueInput = "";
    },

    handleCloseModalAndClear() {
      this.clear();
      this.$bvModal.hide("modalTypeOfSchedule");
    },
  },
  mounted() {
    this.getAllTypeOfSchedule();
  },
};
</script>

<style scoped>
.styleHoverDelete:hover {
  background-color: #ff6347;
  border: solid 1px black;
}

.tabsContentSearch {
  overflow-y: scroll;
  max-height: 300px;
}

.btnsModal {
  border-radius: 5px;
  background-color: #00395d;
  width: 165px;
  height: 28px;
  border: none;
  margin-top: 30px;
  color: white;
  font-size: 12px;
}

.btnSave {
  background-color: transparent;
  border: solid 1px #0fbf4d;
  color: #0fbf4d;
}

.titleCard {
  margin-bottom: 32px !important;
  font-weight: 600;
  color: #666360;
  font-size: 16px;
}
</style>